import { Pagination } from '@components/Table/Pagination';
import { TableHeaderCell } from '@components/Table/TableHeaderCell';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { TableNoResult } from '@components/Table/TableNoResult';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { IContaLinha } from '@model/ContaLinha';
import { IContaLinhaFilter } from '@services/ContaService';
import React from 'react';

export type ContaDetalheTableProps = {
    data: IData<IContaLinha, IContaLinhaFilter>
}

export function ContaDetalheTable ({ data }: ContaDetalheTableProps) {
    const formatter = useFormatter();

    return (
        <TableNoResult itemCount={data.itemsCount}>
            <TableHead>
                <Pagination pagination={data.pagination} />

                <TableRow>
                    <TableHeaderCell>ID</TableHeaderCell>
                    <TableHeaderCell>Numero</TableHeaderCell>
                    <TableHeaderCell>Linha Vinculada</TableHeaderCell>
                    <TableHeaderCell>Vlr. Assinatura</TableHeaderCell>
                    <TableHeaderCell>Vlr. Outros</TableHeaderCell>
                    <TableHeaderCell>Vlr. Total</TableHeaderCell>
                    <TableHeaderCell>Dados (Gb)</TableHeaderCell>
                </TableRow>
            </TableHead>

            <TableBody>
                {
                    data.items.map((contaLinha, index) => {
                        return (
                            <TableRow key={index}>
                                <TableKeyCell>{contaLinha.contaLinhaId}</TableKeyCell>
                                <TableCell>{formatter.toCelular(contaLinha.numero)}</TableCell>
                                <TableCell>{contaLinha.linhaId || "-"}</TableCell>
                                <TableCell>{formatter.toFloat(contaLinha.valorAssinatura)}</TableCell>
                                <TableCell>{formatter.toFloat(contaLinha.valorOutros)}</TableCell>
                                <TableCell>{formatter.toFloat(contaLinha.valor)}</TableCell>
                                <TableCell>{formatter.toFloat(contaLinha.consumoDadosKb / 1024 / 1024)}</TableCell>
                            </TableRow>
                        )
                    })
                }
                <Pagination pagination={data.pagination} />
            </TableBody>
        </TableNoResult>
    )
}